import type { FaireProductEntity } from "../../entity_types/product";

export const p_c5qy5u8st6: FaireProductEntity = {
  token: "p_c5qy5u8st6",
  type: "product",
  name: "Mahjong Stretch Bracelet Stack – 3 Piece Beaded Set",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/c0b32e496ca27044cc529e41ae67afc6f25d6677322389fc15ac3ac030e7730f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30d5a5311a81a83b14774843587cdee25dabb5069c46491249e4fe6da26b3cf0.png",
    "https://cdn.faire.com/fastly/1170ddce0fd121bd1be7efa3e8f914f877f3785799116df01df212f06d501b6b.png",
    "https://cdn.faire.com/fastly/aaad36d047a3d0f1fa8276958309e3d0232cc246e689b43cb7802c38674e3ce1.png",
    "https://cdn.faire.com/fastly/f5a1f9d70a0372a386d5574aed917bd4e7822dcee6589ceb0ee229a5adf3ad45.png",
    "https://cdn.faire.com/fastly/5fddc28a30c44efbc2ad8d45a5bf630cb4beb8e6961e142f63c1c07629158002.png",
  ],
  priceDollars: 12.5,
  description:
    "Mahjong Stretch Bracelet Stack – 3 Piece Beaded Set\n\nStack your style with this charming 3-piece stretch bracelet set inspired by the iconic tiles of Mahjong. Each set pairs a patterned ceramic bead bracelet, a pearl bead bracelet, and a gold ball bracelet — finished with a signature Mahjong tile charm that shows both Side A and Side B. A playful yet polished accessory for the Mahjong lover in your life.\n\n * Set Includes: 3 stretch bracelets (patterned ceramic, pearl, gold ball) \n * Charm: Double-sided Mahjong tile \n * Bracelet Diameter: 55MM \n * Finish: Gold plated metal, lead and nickel compliant \n * Available Styles: Mahjong Bird, Mahjong Bamboo, Mahjong Ivory, Mahjong Blossom \nWhether you're hosting game night or gifting a fellow tile enthusiast, this bracelet stack is the perfect conversation starter.\n",
  tags: [],
  msrpDollars: 31.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:35.249Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
